import vSelect from 'vue-select'
import { required } from '@validations'
import OnlinePaymentApis from '@/services/apis/online-payment'
import { toEnglishDigits, numberWithCommas } from '@/utils'
import moment from '@/libs/moment'

const onlineDeposit = new OnlinePaymentApis()

export default {
  components: {
    vSelect,
  },
  data() {
    return {
      isHidden: true,
      currentpageTransactions: 1,
      totalTransactions: 0,
      perPageTransactions: 10,
      bankCard: [],
      amount: '',
      bank: '',
      cards: [],
      pending: false,
      show: false,
      commission: '',
      currency: '',
      paymentGatewayName: '',
      imgUrl: process.env.VUE_APP_BASE_IMAGE_URL,
      numberWithCommas,
      items: [],
      numbers: '',
      required,
    }
  },
  computed: {
    fields() {
      return [
        {
          label: this.$t('gateway'),
          key: 'gateway',
          tdClass: 'nameOfTheClass',
        },
        {
          label: this.$t('currency'),
          key: 'currency',
          tdClass: 'nameOfTheClass',
        },
        {
          label: this.$t('amount'),
          key: 'amount',
          tdClass: 'nameOfTheClass',
        },
        {
          label: this.$t('date'),
          key: 'date',
          tdClass: 'nameOfTheClass',
        },
        {
          label: this.$t('status'),
          key: 'status',
          tdClass: 'nameOfTheClass',

        },
      ]
    },
  },
  watch: {
    currentpageTransactions(val) {
      if (val) {
        this.getLastTransactions()
      }
    },
  },
  async mounted() {
    await this.bankList()
    await this.gatewayList()
    await this.getLastTransactions()
  },
  methods: {
    async getLastTransactions() {
      this.show = true
      await onlineDeposit.lastTransactions({ current_page: this.currentpageTransactions, per_page: this.perPageTransactions }).then(res => {
        this.totalTransactions = res.data.results.paginate.total
        this.currentpageTransactions = res.data.results.paginate.current_page
        this.perPageTransactions = res.data.results.paginate.per_page
        this.items = res.data.results.data
      }).finally(() => {
        this.show = false
      })
    },
    async bankList() {
      this.show = true
      await onlineDeposit.getBankList({ currency: this.$route.params.token ? this.$route.params.token : undefined }).then(res => {
        const numbers = res.data.results.filter(item => {
          // eslint-disable-next-line no-param-reassign
          item.ibanCurrency = `${item.iban} (${item.currency.currency})`
          return item.check_status === 'success'
        })
        this.bankCard = numbers
        if (this.$route.params.token) {
          if (numbers) {
            // eslint-disable-next-line prefer-destructuring
            this.numbers = numbers[0]
          }
        }
      })
    },
    async gatewayList(currency) {
      this.show = true
      await onlineDeposit.paymentGateway({ currency: currency || (this.$route.params.token ? this.$route.params.token : undefined) }).then(res => {
        this.cards = res.data.results
        const defaultGateway = this.cards.find(item => item.default)
        if (defaultGateway) {
          this.getewaySelected = true
          this.currency = defaultGateway.currency
          this.commission = defaultGateway.commission
          this.paymentGatewayName = defaultGateway.name
        } else {
          this.getewaySelected = false
          this.commission = '0'
          this.paymentGatewayName = ''

          if (this.$route.params.token) {
            this.currency = this.$route.params.token
          }
        }
      }).finally(() => {
        this.show = false
      })
    },
    selectCard(item) {
      // eslint-disable-next-line array-callback-return
      this.cards.map(card => {
        // eslint-disable-next-line no-param-reassign
        card.default = false
      })
      // eslint-disable-next-line no-param-reassign
      item.default = true
      this.getewaySelected = true
      this.currency = item.currency
      this.commission = item.commission
      this.paymentGatewayName = item.name
    },
    numberFormat(value) {
      return this.numberWithCommas(value)
    },
    async payment() {
      const valid = await this.$refs.simpleRules.validate()
      if (valid) {
        this.pending = true
        await onlineDeposit.savePaymentGateway({
          type: 'crypto',
          gateway: this.paymentGatewayName,
          amount: toEnglishDigits(this.amount.replace(/,/g, '')),
          bank_card_number: this.numbers.numbers,
        }).then(res => {
          window.location.replace(res.data.results.url)
        }).catch(err => {
          this.pending = false
          console.log(err)
        })
      }
    },
    getFormattedDate(date) {
      return moment(date).format('YYYY-MM-DD')
    },
  },
}
